$(document).ready(function() {
    let modals = ["Service", "AirConditioning"];
    let urls = {Service:"/wizyta-w-serwisie", AirConditioning:"/wiosenne-czyszczenie-klimatyzacji"}
    for (const modal of modals) {
        $(`#visit${modal}Modal`).submit(function(event) {
            event.preventDefault();
            $('.is-invalid').removeClass('is-invalid');
            $('.invalid-feedback').empty();

            function IsEmail(email) {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            }

            function IsVin(vin) {
                var regex = /^[A-HJ-NPR-Z0-9]{17}$/;
                return regex.test(vin);
            }


            function IsTel(tel) {
                var regex = /^[0-9]{9}$/;
                return regex.test(tel);
            }

            let errors = 0;

            let firstnameInputValue = $(`#form${modal}Firstname`).val();
            let firstname = $(`#form${modal}Firstname`);
            if (!firstname.val()) {
                firstname.addClass('is-invalid');
                $(`.form${modal}Firstname`).siblings('invalid-feedback').prevObject.html("<p>Imię jest wymagane!</p>");
                errors = 1;
            } else {
                firstname.removeClass('is-invalid');
            }

            let lastnameInputValue = $(`#form${modal}Lastname`).val();
            let lastname = $(`#form${modal}Lastname`);
            if (!lastname.val()) {
                lastname.addClass('is-invalid');
                $(`.form${modal}Lastname`).siblings('invalid-feedback').prevObject.html("<p>Nazwisko jest wymagane!</p>");
                errors = 1;
            } else {
                lastname.removeClass('is-invalid');
            }

            let emailInputValue = $(`#form${modal}Email`).val();
            let email = $(`#form${modal}Email`);
            if (email.val()) {
                if (!IsEmail(email.val())) {
                    email.addClass('is-invalid');
                    errors = 1;
                    $(`.form${modal}Email`).siblings('invalid-feedback').prevObject.html("<p>Niepoprawny format email!</p>");
                } else {
                    email.removeClass('is-invalid');

                }
            } else {
                email.addClass('is-invalid');
                $(`.form${modal}Email`).siblings('invalid-feedback').prevObject.html("<p>Email jest wymagany!</p>");
                errors = 1;
            }

            let phoneInputValue = $(`#form${modal}Phone`).val();
            let phone = $(`#form${modal}Phone`);
            if (!phoneInputValue) {
                phone.addClass('is-invalid');
                $(`.form${modal}Phone`).siblings('invalid-feedback').prevObject.html("<p>Podany numer telefonu jest za krótki</p>");
                errors = 1;
            }
            else {
                if (phoneInputValue.length < 7) {
                    phone.addClass('is-invalid');
                    $(`.form${modal}Phone`).siblings('invalid-feedback').prevObject.html("<p>Podany numer telefonu jest za krótki</p>");
                    errors = 1;
                } else {
                    if (!IsTel(phoneInputValue)) {
                        phone.addClass('is-invalid');
                        $(`.form${modal}Phone`).siblings('invalid-feedback').prevObject.html('<p>Wpisz poprawny 9-cyfrowy numer telefonu</p>');
                        errors = 1;
                    } else {
                        phone.removeClass('is-invalid');
                    }
                }
            }

            let dataInputValue = $(`#form${modal}Date`).val();
            let data = $(`#form${modal}Date`);
            if (!data.val()) {
                data.addClass('is-invalid');
                $(`.form${modal}Date`).siblings('invalid-feedback').prevObject.html("<p>Preferowana data wizyty jest wymagana!</p>");
                errors = 1;
            } else {
                data.removeClass('is-invalid');
            }

            let timeInputValue = $(`#form${modal}Time`).val();
            let time = $(`#form${modal}Time`);
            if (!time.val()) {
                time.addClass('is-invalid');
                $(`.form${modal}Time`).siblings('invalid-feedback').prevObject.html("<p>Preferowana godzina wizyty jest wymagana!</p>");
                errors = 1;
            } else {
                time.removeClass('is-invalid');
            }

            let vin = $(`#form${modal}Vin`);
            let vinInputValue = $(`#form${modal}Vin`).val();
            if (!vinInputValue) {
                $(`.form${modal}Vin`).siblings('invalid-feedback').prevObject.html("<p>Proszę podać VIN!</p>");
                vin.addClass('is-invalid');
                errors = 1;
            } else if (!IsVin(vinInputValue)) {
                $(`.form${modal}Vin`).siblings('invalid-feedback').prevObject.html('<p>Niepoprawny format VIN! (17 cyfr)</p>');
                vin.addClass('is-invalid');
                errors = 1;
            } else {
                vin.removeClass('is-invalid');
            }

            let purpose = $(`#form${modal}PurposeVisit`);
            let purposeInputValue = $(`#form${modal}PurposeVisit`).find(":selected").val();
            if (!purposeInputValue) {
                $(`.form${modal}PurposeVisit`).siblings('invalid-feedback').prevObject.html("<p>Proszę podać cel wizyty!</p>");
                purpose.addClass('is-invalid');
                errors = 1;
            } else {
                purpose.removeClass('is-invalid');
            }

            let model = $(`#form${modal}Model`);
            let modelInputValue = $(`#form${modal}Model`).find(":selected").val();
            if (!modelInputValue) {
                $(`.form${modal}Model`).siblings('invalid-feedback').prevObject.html("<p>Proszę wybrać model!</p>");
                model.addClass('is-invalid');
                errors = 1;
            } else {
                model.removeClass('is-invalid');
            }

            let branch = $(`#form${modal}Branch`);
            let branchInputValue = $(`#form${modal}Branch`).find(":selected").val();
            if (!branchInputValue) {
                $(`.form${modal}Branch`).siblings('invalid-feedback').prevObject.html("<p>Proszę wybrać dealera!</p>");
                branch.addClass('is-invalid');
                errors = 1;
            } else  {
                branch.removeClass('is-invalid');
            }

            let commentInputValue = $(`#form${modal}Question`).val();

            let names = ["Regulations1", "Regulations2", "Email", "Phone"];
            let agrees = {};

            for (const name of names) {
                agrees[name] = $(`#form${modal}Agree${name}`).prop('checked');
            }

            if (!agrees['Regulations1'] && !agrees['Email'] && !agrees['Phone']) {
                errors = 1;
                $(`#form${modal}AgreeEmail`).addClass('is-invalid');
                $(`.form${modal}AgreeEmail`).html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
                $(`#form${modal}AgreePhone`).addClass('is-invalid');
                $(`.form${modal}AgreePhone`).html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
                $(`#form${modal}AgreeRegulations1`).addClass('is-invalid');
                $(`.form${modal}AgreeRegulations1`).html('<p>Proszę wyrazić zgodę na co najmniej jeden kanał komunikacji</p>').show();
            }

            if (!agrees['Regulations2']) {
                $(`#form${modal}AgreeRegulations2`).addClass('is-invalid');
                $(`.form${modal}AgreeRegulations2`).siblings('invalid-feedback').prevObject.html('<p>To pole jest wymagane</p>');
                errors = 1;
            } else {
                $(`#form${modal}AgreeRegulations2`).removeClass('is-invalid');
                $(`.form${modal}AgreeRegulations2`).empty();
            }

            var utm_source = getCookie("utmSource");
            var utm_medium = getCookie("utmMedium");
            var utm_campaign = getCookie("utmCampaign");
            var gad_source = getCookie("gadSource");
            var gclid = getCookie("gclid");
            if (errors === 0) {

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: 'formSubmit',
                    form_id: $(`#form${modal}BookType`).val(),
                    firstname: firstnameInputValue,
                    lastname: lastnameInputValue,
                    email: emailInputValue,
                    phone: phoneInputValue,
                    date: dataInputValue,
                    time: timeInputValue,
                    vin: vinInputValue,
                    utm_source: utm_source,
                    utm_medium: utm_medium,
                    utm_campaign: utm_campaign,
                    gad_source: gad_source,
                    gclid: gclid,
                    contact_channel_email: agrees["Email"] ? 1 : 0,
                    contact_channel_phone: agrees["Regulations1"] ? 1 : 0,
                    contact_channel_sms: agrees["Phone"] ? 1 : 0,
                    i_consent_to_the_processing_of_my_data: agrees["Regulations2"] ? 1 : 0,
                    purpose_visit: purposeInputValue,
                    model_id: modelInputValue,
                    branch_id: branchInputValue,
                    comment: commentInputValue,
                    message: commentInputValue,
                    book_type: $(`#form${modal}BookType`).val(),
                    type: $(`#form${modal}BookType`).val()
                });

                $(`#form${modal} .btn-form`).attr("disabled", "true");
                $.ajax({
                    type: 'POST',
                    url: urls[modal],
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        firstname: firstnameInputValue,
                        lastname: lastnameInputValue,
                        email: emailInputValue,
                        phone: phoneInputValue,
                        date: dataInputValue,
                        time: timeInputValue,
                        vin: vinInputValue,
                        utm_source: utm_source,
                        utm_medium: utm_medium,
                        utm_campaign: utm_campaign,
                        gad_source: gad_source,
                        gclid: gclid,
                        contact_channel_email: agrees["Email"] ? 1 : 0,
                        contact_channel_phone: agrees["Regulations1"] ? 1 : 0,
                        contact_channel_sms: agrees["Phone"] ? 1 : 0,
                        i_consent_to_the_processing_of_my_data: agrees["Regulations2"] ? 1 : 0,
                        purpose_visit: purposeInputValue,
                        model_id: modelInputValue,
                        branch_id: branchInputValue,
                        comment: commentInputValue,
                        message: commentInputValue,
                        book_type: $(`#form${modal}BookType`).val(),
                        type: $(`#form${modal}BookType`).val()
                    },
                    success: function(result) {
                        $(`#form${modal} .btn-form`).removeAttr("disabled");
                        if (result.success === 1) {
                            $(`#form${modal}`).trigger("reset");
                            $(`#visit${modal}Modal`).modal('hide');
                            $('#formSuccess').modal('show')
                        } else {
                            alert('Zapis nie powiódł się. Spróbuj ponownie');
                        }
                    }
                });
            }
        });

        function getCookie(cookieName) {
            var name = cookieName + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for (var i = 0; i < cookieArray.length; i++) {
                var cookie = cookieArray[i];
                while (cookie.charAt(0) === ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) === 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        }
    }


});
